import { Observable } from 'rxjs';
import { UliActivityType } from '../../../../../../common/constants';
import { AllocationViewActionIdentifierTypeEnum } from '../../constants';

export class ActionBriefModel {
  hubId: number | null = null;
  compartmentId: number | null = null;
  uliCompartmentId: number | null = null;
  allocatedCompartmentId: number | null = null;
  truckId: number | null = null;
  uli: string | null = null;
  slotId: number | null = null;
  type: UliActivityType | null = null;
  actionOrigin: AllocationViewActionIdentifierTypeEnum | null = null;

  constructor(params?: Partial<ActionBriefModel>) {
    if (params) {
      Object.assign(this, params);
    }
  }
}

export interface ActionBriefInterface {
  actionBriefDetails$: Observable<ActionBriefModel>;
}

export abstract class ActionBrief implements ActionBriefInterface {
  abstract actionBriefDetails$: Observable<ActionBriefModel>;
}
